import React, { useState } from 'react';
import Card from '../common/Card.jsx';
import DateLocation from './DateLocation.jsx';
import TicketDetails from './TicketDetails.jsx';
import Barcode from '../order-details/Barcode.jsx';


export default function Ticket({ data, count, hasLabel, reservationExpired, orderStatus }) {

    const ticketDetails = {
        nameSurname: data.nameSurname,
        zone: data.zone,
        section: data.section,
        rowSeat: data.rowSeat ,
        price: data.price
    };

    const dateLocation = {
        customDate: data.customDate,
        customTime:data.customTime,
        date: data.eventDateTime,
        location: data.location,
        culture:data.culture
    };

    const googleWalletLink = `/_api/ticket-management/GetGooglePayPass/${data.contentId}/${data.id}`;
    const appleWalletLink = `/_api/ticket-management/GetAppleWalletPass/${data.contentId}/${data.id}`;

    //Multiple passes
    const googleWalletBundleLink = `/_api/ticket-management/GetGooglePayPass/${data.contentId}`;
    const appleWalletBundleLink = `/_api/ticket-management/generateAppleWalletPassZip/${data.contentId}`;

    const walletsLinks = {
        apple: appleWalletLink,
        google: googleWalletLink,
        appleBundle: appleWalletBundleLink,
        googleBundle: googleWalletBundleLink
    }

    const cardProps = {
        detailsTop: <DateLocation dateLocation={dateLocation} type="card" gap={4} align={'center'} margin={4} hasWeekday />,
        detailsBottom: <TicketDetails  details={ticketDetails} />,
        barcode: <Barcode code={data.barcode} eventId={data.eventId} />,
        status: data.status,
        title: data.title,
        imageUrl: data.imageUrl,
        gov: {
            "ticketId": data.id,
            "isGovWalletEnabled": data.isGovWalletEnabled,
            "govStatus":data.govStatus
        }
    };

    return (
        
        <Card id="ticketCard" cardProps={cardProps} count={count} type="card" hasLabel={hasLabel} walletsLinks={walletsLinks} reservationExpired={reservationExpired} orderStatus={orderStatus}/>
    );
}